var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.34 1300.01",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c0a00",
    d: "M55.55 55.55h1222.23v1188.9H55.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.55 55.55h1222.23v1188.9H55.55V55.55zM0 1300.01h1333.34V0H0v1300.01zm873.33-836.68c0-4.44 1.67-6.67 6.67-6.67h87.22c4.44 0 6.67 1.67 6.67 6.67v438.34c0 4.44-1.11 6.67-6.67 6.67h-86.11c-5.56 0-7.22-2.78-7.22-7.22V463.34h-.56zm-6.11-126.11c0-35.56 25-56.67 56.67-56.67 33.89 0 56.67 22.78 56.67 56.67 0 36.67-23.89 56.67-57.78 56.67-32.22 0-55.56-20-55.56-56.67zm-250 308.89C601.67 584.44 565 450 551.11 385H550c-11.67 65-41.11 175-64.45 261.11h131.67zm-154.45 90l-43.89 166.67c-1.11 4.44-2.78 5.55-8.33 5.55h-81.67c-5.56 0-6.67-1.67-5.56-8.33L481.1 347.77c2.78-10 4.44-18.89 5.56-46.11 0-3.89 1.67-5.56 4.44-5.56h116.67c3.89 0 5.56 1.11 6.67 5.56l176.67 599.45c1.11 4.44 0 7.22-4.44 7.22h-92.22c-4.44 0-7.22-1.11-8.33-5l-45.56-167.22H462.78z",
    fill: "#ff7f18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.a7a02e07de1f428028102a5f4c6760de.svg";
export { ForwardRef as ReactComponent };